import React from 'react';
import {Link} from "react-router";
import {
    AndroidMockup
}
    from "react-device-mockup"


function Lenovo() {
    return (
        <React.Fragment>
            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
                                <span className="breadcumb__title">
                                    <span className="breadcumb__title-lighten"
                                          style={{color: "#0a0a0a"}}>LENOVO</span> DEMO
                                </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">YAPAY ZEKA DEMO</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <div className="container">
                <div className="container d-flex justify-content-center">
                    <div className="p-4 bg-light border rounded">
                        <AndroidMockup

                            screenWidth={300}>
                            <iframe
                                title="Yoga7 Ad"
                                src="https://depo.clerkai.app/lenovo/lenovo.html"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 'none',
                                }}
                            />
                        </AndroidMockup>
                    </div>
                </div>


            </div>
            <br/>
        </React.Fragment>
    );
}

export default Lenovo;